import { Flex, Image, styled } from '@grupoboticario/flora-react';

const styles = {
  LogoImage: styled('div', {
    height: '$10',
  }),

  LogoWrapper: styled(Flex, {
    alignItems: 'center',
    flexDirection: 'column',
    gap: '$2',
    textAlign: 'center',
  }),

  Image: styled(Image, {
    "&[data-brand='bot']": {
      width: '228px',
      height: '48px',
    },
    "&[data-brand='eud']": {
      width: '232px',
      height: '42px',
    },
  }),
};

export default styles;
